import { Button } from "@/components/ui/button";
import { useTranslation } from 'react-i18next';

interface SuccessPanelProps {
  onApplyAgain: () => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  fetchJobs: () => void;
}

export function SuccessPanel({ onApplyAgain, fileInputRef, fetchJobs }: SuccessPanelProps) {
  const { t } = useTranslation();
  
  return (
    <div className="text-center py-8">
      <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
        <svg 
          className="h-8 w-8 text-green-600" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
          aria-hidden="true"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M5 13l4 4L19 7" 
          />
        </svg>
      </div>
      <h3 className="text-xl font-semibold mb-2">
        {t('careers.successPanel.title', 'Application Submitted!')}
      </h3>
      <p className="text-muted-foreground">
        {t('careers.successPanel.message', 'We\'ll review your profile and get back soon.')}
      </p>
      <Button
        className="mt-4"
        onClick={() => {
          onApplyAgain();
          if (fileInputRef.current) fileInputRef.current.value = '';
          fetchJobs();
        }}
      >
        {t('careers.successPanel.applyAgain', 'Apply for Another Role')}
      </Button>
    </div>
  );
}